var React = require('react');

function Tz (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fillOpacity":".7","d":"M10 0h160v120H10z"}))),React.createElement("g",{"fillRule":"evenodd","strokeWidth":"1pt","clipPath":"url(#a)","transform":"matrix(4 0 0 4 -40 0)","key":1},[React.createElement("path",{"fill":"#09f","d":"M0 0h180v120H0z","key":0}),React.createElement("path",{"fill":"#090","d":"M0 0h180L0 120V0z","key":1}),React.createElement("path",{"d":"M0 120h40l140-95V0h-40L0 95v25z","key":2}),React.createElement("path",{"fill":"#ff0","d":"M0 91.5L137.2 0h13.5L0 100.5v-9zM29.3 120L180 19.5v9L42.8 120H29.3z","key":3})])]);
}

Tz.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Tz;

Tz.default = Tz;
